"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @ts-nocheck

var v4_1 = __importDefault(require("uuid/v4"));

function initialState() {
  return {
    class: "claim",
    type: null,
    // ALL --
    subType: null,
    subTypeOtherDescription: null,
    creditor: null,
    accountNumber: null,
    interest: null,
    community: null,
    date: null,
    isContingent: false,
    isDisputed: false,
    isUnliquidated: false,
    offset: false,
    codebtors: [],
    value: 0,
    // Secured --
    valueCollateral: null,
    valueUnsecured: null,
    lienAgreement: false,
    lienStatutory: false,
    lienJudgment: false,
    lienOther: false,
    otherLeinDescription: null,
    exempt: false,
    assetDescription: null,
    // Unsecured --
    notify: [],
    // Unsecured Priority --
    valuePriority: null,
    valueNonPriority: null,
    // Extras --
    status: null,
    additionalDescription: null,
    source: null // Is it from docassemble interview or directly from meridian?

  };
}

var createClaim = function createClaim(attrs) {
  return _objectSpread(_objectSpread(_objectSpread({}, initialState()), attrs), {}, {
    id: (0, v4_1.default)()
  });
};

exports.default = createClaim;